import { createContentPropTypes } from '../../../helpers/content';

const content = {
	header: 'Payment submitted for authorisation',
	subHeader:
		'Your payment has now been submitted and is awaiting authorisation. You can see more information about your payment below.',
	AwaitingAuthHeader: 'Authorisation Required',
	singlePaymentSubHeader:
		'Your transaction has now been submitted. If you want to check if it’s gone through yet, please click ‘Check payment status’',
	accountsButtonLabel: 'Go to your accounts',
	anotherPaymentButtonLabel: 'Make another payment or transfer',
	paymentStatusButtonLabel: 'Check payment status',
	authorisationRequired: 'Authorisation Required',
	authorisationNavigationButton: 'Continue to authorise',
	importantInfoHeader: '<IndicativeHighlight.description>*Important information</IndicativeHighlight.description>',
	importantInfoText:
		'Your payment will be submitted using an indicative rate – this means the <IndicativeHighlight.description>figures highlighted are subject to change</IndicativeHighlight.description> until the payment is approved. The exact amounts will be clearly shown when it comes to authorising the payment.<p> </p><p>The settlement date has been estimated based on the payment being authorised by the cut-off time on the planned submission date.</p><p>Please note that any fees you’ve agreed to pay will be taken from your account as a separate payment.</p>',
	softToken: 'Log in to your mobile banking app',
	hardToken: 'Use your security token',
	thirdParty: 'By',
	authListHeader: 'Payments to authorise',
	failedListHeader: 'Failed payments',
	authoriseButtonText: 'Continue to authorise',
	authorisationOnSubmissionDate: 'Use your security device on the payment submission date.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
